import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { APP_ROLES, SUPERVISR_ORGANIZATION, UiUserProfile } from '@origin8-web/models/core-business';
import { computed } from '@angular/core';
import { UserState } from '../../../app.interface';

const initialState: UserState = {
  userInfo: null,
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => {
    return {
      loggedIn: computed(() => store.userInfo() !== null),
      isSupervisrAdmin: computed(() => store.userInfo()?.organization === SUPERVISR_ORGANIZATION),
      isSupervisrReadOnly: computed(
        () => store.userInfo()?.authorizations.roles.includes(APP_ROLES.SUPERVISR_READ_ONLY) ?? false,
      ),
    };
  }),
  withMethods((store) => {
    return {
      setUserInfo: (userInfo: UiUserProfile | null | undefined) => patchState(store, { userInfo }),
    };
  }),
);
